/**
 * Copyright © 2026 Adnuntius AS.
 */
import * as _ from 'lodash';

export function creativeListCommons(ctrl: any, afterFill: boolean, LocalNetworkProfile: any, $state: any): void {
  _.forEach(ctrl.items, (c: any) => {
    c.previewUrl = $state.href('nude.preview', {
      creativeId: c.id,
      networkId: c.network.id,
      creativeWidth: c.width,
      creativeHeight: c.height,
      lineItemId: c.lineItemId,
      lineItemCode: c.lineItemCode
    }, {absolute: true});
  });

  if (afterFill) {
    return;
  }

  ctrl.hasObjectSource = LocalNetworkProfile.hasObjectSource();
  ctrl.creativeFields = ['name', {param: 'Layout', label: 'layout'}, {param: '', label: 'parent'}, {label: 'URLs', param: ''}, {label: 'impressionTrackingUrls', param: ''}, {label: 'dimensions', param: 'width'}, {param: '', label: 'info'}, {param: '', label: 'preview'}, 'updateTime', {param: '', label: 'targeting'}];
  if (ctrl.hasObjectSource) {
    ctrl.creativeFields.splice(3, 0, 'source');
  }

  const skipForDefaults = ['source', 'impressionTrackingUrls', 'targeting'];
  ctrl.defaultFields = _.filter(ctrl.creativeFields, (f: any) => {
    return skipForDefaults.indexOf(f.label || f.param || f) < 0;
  });
  ctrl.sel = {};
}

export function postFillGenerateFormatFees(ctrl: any): {validItems: any[]; creativeFormatFees: any[]} {
  const validItems = _.filter(ctrl.items, (item: any) => {
    return !_.find(item.validationWarnings, (vw: any) => {
      return vw.preventsAdServing;
    });
  });

  const creativeFormatFees = _.map(_.filter(validItems, (item: any) => {
    return _.get(item.creativeFormatFee, ['monetary', 'amount']) > 0 || (_.get(item.creativeFormatFee, ['multiCurrencyMonetaryAmounts', 'length']) > 0 && _.find(_.get(item.creativeFormatFee, ['multiCurrencyMonetaryAmounts']), (fee: any) => {
      return fee.amount > 0;
    }));
  }), (item: any) => {
    return item.creativeFormatFee;
  });

  return {validItems: validItems, creativeFormatFees: creativeFormatFees};
}
